import React, { useState } from "react";
import { Copy, Check, FileText } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const SubstackExportButton = ({ seriesSlug, chapterNumber, accentColor }) => {
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/chapter-export/${seriesSlug}/${chapterNumber}`);
      await navigator.clipboard.writeText(res.data.html);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={loading}
      data-testid="substack-export-btn"
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs border border-ff-border text-ff-text-muted hover:text-ff-text hover:border-ff-text-muted transition-all disabled:opacity-50"
      title="Copy chapter as Substack-ready HTML"
    >
      {copied ? (
        <>
          <Check size={12} className="text-green-400" />
          <span>Copied HTML</span>
        </>
      ) : (
        <>
          <FileText size={12} />
          <span>{loading ? "Copying..." : "Copy for Substack"}</span>
        </>
      )}
    </button>
  );
};

export default SubstackExportButton;
